import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { Fragment } from "react";
import Home from "./components/Home";
import LandingPage from "./components/LandingPage";
import Erbil from "./components/Erbil";
import Mosul from "./components/Mosul";
import Dohuk from "./components/Dohuk";
import Baghdad from "./components/Baghdad";
import Koya from "./components/Koya";
import Hamdanyah from "./components/Hamdanyah";
import Alraqa from "./components/Alraqa";
const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<LandingPage />} />
        <Route path="/Erbil" element={<Erbil />} />
        <Route path="/mosul" element={<Mosul />} />
        <Route path="/dohuk" element={<Dohuk />} />
        <Route path="/baghdad" element={<Baghdad />} />
        <Route path="/koya" element={<Koya />} />
        <Route path="/hamdanyah" element={<Hamdanyah />} />
        <Route path="/alraqa" element={<Alraqa />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
